import { useState } from "react";
import { Button, Table, Typography } from "antd";
import {
  downloadFile,
  downloadFileUnifiedById,
  fallbackString,
  formatDate,
  useIsUnifiedMode,
} from "@/shared/utils";
import { DocumentationPermissions } from "@entities/api/object/types.ts";
import "./object-info-permission.scss";

const { Title } = Typography;

export const ObjectInfoPermission = (props: {
  data: DocumentationPermissions[];
}) => {
  const { data } = props;

  const [loadingFileIds, setLoadingFileIds] = useState<Record<string, boolean>>(
    {},
  );

  const setLoading = (fileId: string, loading: boolean) => {
    setLoadingFileIds((prev) => ({ ...prev, [fileId]: loading }));
  };

  const isUnifiedMode = useIsUnifiedMode();

  const columns = [
    {
      title: "№ разрешения",
      dataIndex: "number",
      key: "number",
      render: (text: string, record: DocumentationPermissions) => {
        const fileId =
          record.permissionFile.file?.fileId ||
          record.permissionFile.signature?.fileId;

        if (fileId) {
          return (
            <Button
              type="link"
              loading={loadingFileIds[fileId]}
              onClick={() => {
                if (isUnifiedMode) {
                  downloadFileUnifiedById(fileId as string, setLoading);
                } else {
                  downloadFile(fileId as string, setLoading);
                }
              }}
            >
              {text}
            </Button>
          );
        }
        return <>{text}</>;
      },
    },
    {
      title: "Дата выдачи",
      dataIndex: "date",
      key: "date",
      render: (text: string | null) => fallbackString(formatDate(text)),
    },
    {
      title: "Наименование органа, выдавшего разрешение",
      dataIndex: "issued",
      key: "issued",
      render: (text: string) => (
        <div className="object-info-permission__issued-cell">{text}</div>
      ),
    },
    {
      title: "Срок действия",
      dataIndex: "expiryDate",
      key: "expiryDate",
      render: (text: string | null) => fallbackString(formatDate(text)),
    },
    {
      title: "Продлено до",
      dataIndex: "prolongDate",
      key: "prolongDate",
      render: (text: string | null) => fallbackString(formatDate(text)),
    },
  ];

  return (
    <div className="table-container">
      <Title level={5}>Разрешения на строительство</Title>
      <Table
        dataSource={data}
        columns={columns}
        pagination={false}
        className="custom-table"
        scroll={{ x: true }}
      />
    </div>
  );
};
